export const ROLE_STAFF = "ROLE_STAFF";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_TEACHER = "ROLE_TEACHER";
export const ROLE_ACCOUNTANT = "ROLE_ACCOUNTANT";
export const ROLE_RECEPTIONIST = "ROLE_RECEPTIONIST";
export const ROLE_CLASS_TEACHER = "ROLE_CLASS_TEACHER";
export const ROLE_USER = "ROLE_USER";
